import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from 'store/model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { NowLineLock } from './models/line-lock';
import { NowLineLockAuthCheck } from './models/line-lock-auth';


@Injectable()
export class NowLineLockApi {
    public static enableDisableLineLock(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<NowLineLock> {
        return http.post('/now/lock/line', params, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: NowLineLock) =>
                NowLineLock.create<NowLineLock>({ ...response, lineId: params.lineId }))
        );
    }

    public static checkNowLineLockAuthorization(_xmStore: XmStore, http: HttpClient): Observable<NowLineLockAuthCheck> {
        return http.get('/step-up/line-lock', {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: NowLineLockAuthCheck) =>
                NowLineLockAuthCheck.create<NowLineLockAuthCheck>(response))
        );
    }
}

ModelBase.persistMapping[StoreAction.POST_LINE_LOCK] = NowLineLockApi.enableDisableLineLock;
ModelBase.fetchMapping[StoreAction.GET_NOW_LINE_LOCK_AUTH_CHECK] = NowLineLockApi.checkNowLineLockAuthorization;
